import React, { useContext, useState, useEffect } from "react";
import {
    Button, Toolbar, Typography, IconButton, Dialog, AppBar, Slide, Container, Table, TableRow, TableCell, TableHead, TableBody, TextField
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles';
import { Row, Col } from "react-bootstrap";
import AuthContext from '../../context/auth-context'
import mKategori from './Kategori.controller'
import moment from 'moment'
import { isArray } from 'util'
import DeleteIcon from '@material-ui/icons/Delete';
// import { array } from "prop-types";
// import DialogInfo from '../../Dialog/DialogInfo'
import validate from 'validate.js';

var dateNow = moment();
// const tgl = dateNow.format("YYMMDDHHmmss")
const DialogEditkategori = (props) => {
    const classes = useStyles();
    const kodekategori = props.item
    const kodeoutlet = props.kodeoutlet
    const { clientID, token } = useContext(AuthContext)
    const [addRow, setAddRow] = useState(dateNow.format("YYMMDDHHmmss") * 1 + 0)
    const [listKategori, setListKategori] = useState([])
    // const [OpenConfirmInfo, setOpenConfirmInfo] = useState(false)
    // const [dialogtext, setDialogtext] = useState()

    const handleClose = () => {
        props.setOpen(false);
    }
    const SimpanKategori = () => {
        const validasiError = []
        listKategori.map(el => {
            const { namakategori } = el;
            const constraint = {
                namakategori: {
                    length: {
                        minimum: 3,
                        message: "Nama Kategori minimal terdiri dari 3 huruf"
                    },
                }
            }
            const validator = validate({ namakategori }, constraint, { fullMessages: false });
            if (validator) {
                const err = [validator][0]
                const keys = Object.keys(err);
                var errorMessage = "";
                for (const key of keys) {
                    errorMessage += err[key] + "\n";
                }
                validasiError.push(errorMessage)
                return
            }
        })
        if (validasiError.length > 0) return alert(validasiError[0])
        mKategori.importKategori(kodeoutlet, listKategori, clientID, token).then(resp => {
            //  setIsLoading(false);
            if (resp) {
                alert("Data Berhasil Di Simpan")
                props.setOpen(false);
                props.setIsRefresh(true);
                props.setSelected([])
                props.notif()
            } else {
                alert("Data Gagal Di Simpan")
            }
        }).catch(err => {
            if (isArray(err) && err.length > 0) {
                alert(`Gagal Simpan :  ${err[0].message}`)
            } else if (typeof err == 'error') {
                alert(err.message)
            } else {
                console.log(err);
            }
        })
    }
    const handleaddRow = () => {
        setAddRow(addRow + 1)
        setListKategori([
            ...listKategori,
            {
                kodekategori: addRow,
                namakategori: "",
                isInsert: true
            }
        ])
    }

    useEffect(() => {
        if (kodekategori == null) {
            setAddRow(addRow + 1)
            setListKategori([
                {
                    kodekategori: addRow,
                    namakategori: "",
                    isInsert: true
                }
            ])
        } else {
            var render = true
            mKategori.getData(kodeoutlet, clientID, token, kodekategori).then(resp => {
                if (render) setListKategori(resp);
            }).catch(err => {
                console.error(err);
            })
            return () => {
                render = false
            };
        }

    }, [kodeoutlet, clientID, token]);
    const handleChange = (ev, kodekategori) => {
        var value = ev.target.value;
        const key = ev.target.id || ev.target.name;
        const dataUpdate = []
        let b = listKategori.map(el => {
            if (el.kodekategori == kodekategori) {
                if (key == "namakategori") {
                    return {
                        ...el,
                        kodekategori: kodekategori,
                        namakategori: value
                    }
                } else if (key == "kodekategori") {
                    return {
                        ...el,
                        kodekategori: value,
                        namakategori: el.namakategori
                    }
                }
            } else return el
        })
        setListKategori(b)
    }
    const deleteRow = (data) => {
        let a = listKategori.filter(el => {
            return el.kodekategori !== data.kodekategori
        })
        setListKategori(a)
    }
    return (
        <Dialog fullScreen open={props.open} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="close" onClick={handleClose} >
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Edit Kategori</Typography>
                    <Button color="inherit" onClick={SimpanKategori}>
                        save</Button>
                </Toolbar>
            </AppBar>
            <Container className="DialogFont bodyDialog">
                <Row className={classes.root}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell className="colorWhite" style={{ minWidth: ' 250px' }}>Kode Kategori</TableCell>
                                <TableCell className="colorWhite" style={{ minWidth: ' 350px' }}>Nama kategori</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listKategori.map((data, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row" className="colorWhite">
                                            {!data.isInsert && (data.kodekategori)}
                                            {data.isInsert && (
                                                <React.Fragment>
                                                    <Row>
                                                        <Col xs={2} md={1}>
                                                            <DeleteIcon className="deleteDialog" onClick={deleteRow.bind(this, data)} />
                                                        </Col>
                                                        <Col xs={10} md={11}>
                                                            <span className="tabelForm">
                                                                <TextField
                                                                    id="kodekategori"
                                                                    name="kodekategori"
                                                                    label=""
                                                                    fullWidth
                                                                    required
                                                                    multiline={false}
                                                                    value={data.kodekategori}
                                                                    variant="outlined"
                                                                    onChange={(ev) => handleChange(ev, data.kodekategori)}
                                                                />
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </React.Fragment>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                id="namakategori"
                                                name="namakategori"
                                                label=""
                                                fullWidth
                                                required
                                                multiline={false}
                                                value={data.namakategori}
                                                variant="outlined"
                                                onChange={(ev) => handleChange(ev, data.kodekategori)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Row>
                <Row>
                    <Button className="marginTop15" variant="contained" color="primary" component="span" onClick={handleaddRow}>Add Row</Button>
                    {/* <DialogInfo open={OpenConfirmInfo} setOpen={setOpenConfirmInfo} text={dialogtext} /> */}
                </Row>
            </Container>
        </Dialog>
    )
}
export default DialogEditkategori;
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles(theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(1),
        overflowX: 'auto',
        overflowY: 'hidden',
    },
}));